// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__M2ZiO","Footer__noPrice":"Footer_Footer__noPrice__ZTM1Y","Footer__price":"Footer_Footer__price__Y2M2M","Footer__view":"Footer_Footer__view__ODVhY"};